import { DollarSign, TrendingUp, TrendingDown } from 'lucide-react';

const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(a || 0);

export function PartnerColumn({ name, role, share, color, pct }) {
  return (
    <div className={`bg-white rounded-xl border-2 ${color} p-6`}>
      <div className="text-center mb-6">
        <div className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3 ${color.replace('border-', 'bg-').replace('200', '50').replace('300', '100')}`}>
          <span className="text-xl font-bold">{name.split(' ').map(n => n[0]).join('')}</span>
        </div>
        <h3 className="text-lg font-bold text-[#0A1628]">{name}</h3>
        <p className="text-xs text-gray-500">{role}</p>
      </div>
      <div className="bg-gray-50 rounded-xl p-4 text-center">
        <p className="text-xs text-gray-400 uppercase font-semibold mb-1">Monthly Share ({pct || '33%'})</p>
        <p className={`text-3xl font-bold ${share >= 0 ? 'text-green-600' : 'text-red-500'}`}>{fmt(share)}</p>
      </div>
    </div>
  );
}

export function PartnerSummaryRow({ income, expenses, net }) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-2"><TrendingUp className="w-4 h-4 text-green-600" /><p className="text-xs text-gray-400 uppercase font-semibold">Total Income</p></div>
        <p className="text-2xl font-bold text-green-600">{fmt(income.total)}</p>
        <div className="text-xs text-gray-500 mt-2 space-y-0.5">
          <p>Invoices: {fmt(income.invoices)}</p>
          <p>Stripe: {fmt(income.stripe)}</p>
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-2"><TrendingDown className="w-4 h-4 text-red-500" /><p className="text-xs text-gray-400 uppercase font-semibold">Total Expenses</p></div>
        <p className="text-2xl font-bold text-red-500">{fmt(expenses.total)}</p>
        <div className="text-xs text-gray-500 mt-2 space-y-0.5">
          <p>System: {fmt(expenses.system_costs)}</p>
          <p>Vendors: {fmt(expenses.vendor_costs)}</p>
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-2"><DollarSign className={`w-4 h-4 ${net >= 0 ? 'text-green-600' : 'text-red-500'}`} /><p className="text-xs text-gray-400 uppercase font-semibold">Net Profit</p></div>
        <p className={`text-2xl font-bold ${net >= 0 ? 'text-green-600' : 'text-red-500'}`}>{fmt(net)}</p>
        <p className="text-xs text-gray-500 mt-2">Danny 45% / Mel 45% / DME R'US 10%</p>
      </div>
    </div>
  );
}
